import { CATEGORY_NECESSARY } from '../config/constants';
import hasCookieCategoryConsent from './hasCookieCategoryConsent';

const hasCookieConsent = () => hasCookieCategoryConsent(CATEGORY_NECESSARY);

export default hasCookieConsent;
